export const sideMenuImages = {
  history_1_icon: 'assets/menu-customisation-icons/History/history1.svg',
  history_2_icon: 'assets/menu-customisation-icons/History/history2.svg',
  history_3_icon: 'assets/menu-customisation-icons/History/history3.svg',
  history_4_icon: 'assets/menu-customisation-icons/History/history4.svg',
  history_5_icon: 'assets/menu-customisation-icons/History/history5.svg',

  pin_1_icon: 'assets/menu-customisation-icons/Pin/pin1.svg',
  pin_2_icon: 'assets/menu-customisation-icons/Pin/pin2.svg',
  pin_3_icon: 'assets/menu-customisation-icons/Pin/pin3.svg',
  pin_4_icon: 'assets/menu-customisation-icons/Pin/pin4.svg',
  pin_5_icon: 'assets/menu-customisation-icons/Pin/pin5.svg',
  pin_6_icon: 'assets/menu-customisation-icons/Pin/pin6.svg',
  pin_7_icon: 'assets/menu-customisation-icons/Pin/pin7.svg',
  pin_8_icon: 'assets/menu-customisation-icons/Pin/pin8.svg',
};
